import { createAction, handleActions } from 'redux-actions'
import Moment from 'moment'
import api from '../api'

const GET_DATA_GRAPH = createAction('subscriptions-admin/GET_DATA_GRAPH')
const GET_DATA_GRAPH_SUCCESS = createAction('subscriptions-admin/GET_DATA_GRAPH_SUCCESS')
const GET_DATA_GRAPH_ERROR = createAction('subscriptions-admin/GET_DATA_GRAPH_ERROR')

const initialState = {
  graph: {
    data: [],
    sms: [],
    dates: []
  },
  loading: false
}

export default handleActions(
  {
    [GET_DATA_GRAPH]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_DATA_GRAPH_SUCCESS]: (state, action) => {
      let graph = state.graph
      graph = {
        data: action.payload.dataRemaining,
        sms: action.payload.smsPercentage,
        dates: action.payload.dates
      }
      return { ...state, graph: graph, loading: false }
    },
    [GET_DATA_GRAPH_ERROR]: (state, action) => ({
      ...state,
      loading: false
    })
  },
  initialState
)

export const getDataGraph = (id, fromDate, toDate) => {
  return (dispatch, getState) => {
    dispatch(GET_DATA_GRAPH())
    return api
      .get(
        'subscriptionsadmin/getDataGraph',
        id,
        `from=${Moment(fromDate).format('YYYY-MM-DD')}&to=${Moment(toDate).format('YYYY-MM-DD')}`
      )
      .then(result => {
        dispatch(GET_DATA_GRAPH_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_DATA_GRAPH_ERROR())
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/subscriptions-admin/graph.js